import { useGroupComponentProps } from '../common/lobby/useGroupComponentProps';
import { useGroupsPreview } from '../common/lobby/useGroupsPreview';
import { GlobalDesignActionLobbyItem, GlobalDesignStyleGroup } from '../types';
import { StrictGroupValueEntries } from '../common/lobby/types';
import React from 'react';

const getDefaultValue = (group: GlobalDesignStyleGroup) => ({
  blurRadius: null,
  position: {
    value: '',
    label: group.displayName,
  },
  isMixed: false,
});

const ShadowLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const GroupPreviewComponent = useGroupsPreview('boxShadow', props.group);
  const groupComponentProps = useGroupComponentProps<
    ReturnType<typeof getDefaultValue>,
    'BoxShadow'
  >(props.group, getDefaultValue(props.group), (acc, styleValues) => {
    const styleValueEntries = Object.entries(
      styleValues,
    ) as StrictGroupValueEntries<'BoxShadow'>;

    // @ts-expect-error - TODO: ds-types-bump
    styleValueEntries.forEach(([key, style]) => {
      if (!style) {
        return;
      }

      if (key === 'blurRadius') {
        if (!acc.blurRadius) {
          acc.blurRadius = style.value;
        } else if (acc.blurRadius.value !== style.value) {
          acc.isMixed = true;
        }
      }

      if (key === 'position') {
        if (!acc.position.value) {
          acc.position.value = style.value;
        } else if (acc.position.value !== style.value) {
          acc.isMixed = true;
        }
      }
    });

    return acc;
  });

  const boxShadow = () => {
    const blurRadius = groupComponentProps.blurRadius
      ? `${groupComponentProps.blurRadius}px`
      : '6px';

    return `0 2px ${blurRadius} 0 grey`;
  };

  if (!GroupPreviewComponent) {
    return null;
  }

  return (
    <GroupPreviewComponent
      value={{
        ...groupComponentProps,
        boxShadow: boxShadow(),
      }}
      onClick={props.onSelect}
    />
  );
};

export default ShadowLobbyItem;
